import React from "react";

interface TableHeaderProps {
  children?: React.ReactNode;
  className?: string;
  width?: string;
}

export const TableHeader: React.FC<TableHeaderProps> = ({ 
  children, 
  className = "", 
  width = "w-auto"
}) => {
  return (
    <th className={`${width} px-2 md:px-4 py-1 text-left ${className}`}>
      <span className="text-body font-body text-subtext-color">
        {children}
      </span>
    </th>
  );
}; 